
var util = require('../../util/property-util');
var arrayUtil = require('../../util/array-util');

module.exports = /*@ngInject*/ ["$scope", "$timeout", "FleetDashboardFactory", "DashboardFactory", "HighChartFactory", "ProjectService", function ($scope, $timeout, FleetDashboardFactory, DashboardFactory, HighChartFactory, ProjectService) {
    $scope.dashboard = {};
    var chart = undefined;
    init();

    function init() {
        chart = HighChartFactory.createChart('chart-container');
        var projectId = ProjectService.getSelectedProjectId();

        FleetDashboardFactory.getProjectSqiGauges(projectId, linkSqiIdToDivId);
        FleetDashboardFactory.getProjectConsumptionData(projectId, function (data) {
            $scope.dashboard.consumption = data;
        });
        FleetDashboardFactory.getProjectSynchronizationState(projectId, function (data) {
            $scope.dashboard.content = data;
        });

        var promise = FleetDashboardFactory.fetchTrainData(projectId);
        promise.then(function (map) {
            var processedMap = DashboardFactory.processTrainData(map);
            // create axes
            DashboardFactory.createAxes(chart, processedMap);
            // create series
            DashboardFactory.createSeries(chart, processedMap);
            $timeout(function () {
                chart.reflow();
                chart.redraw();
            }, 100);
            pollData();
        });
    }

    function createChart(dataMap, axesMap, graphMap) {

        var data = mapToAmDataProviderArray(dataMap);
        var axisList = arrayUtil.getMapValueAsList(axesMap);
        var graphList = arrayUtil.getMapValueAsList(graphMap);

        chart = AmCharts.makeChart("fleetchart", {
            "type": "serial",
            "theme": "none",
            "pathToImages": "http://www.amcharts.com/lib/3/images/",
            "legend": {
                "useGraphSettings": true
            },
            "dataProvider": data,
            "valueAxes": axisList,
            "graphs": graphList,
            "chartScrollbar": {},
            "chartCursor": {
                "categoryBalloonDateFormat": "JJ:NN:SS, DD MMMM",
                "cursorPosition": "mouse"
            },
            "categoryField": "timestamp",
            "categoryAxis": {
                "parseDates": true,
                "axisColor": "#DADADA",
                "minorGridEnabled": true,
                "minPeriod": "fff"
            },
            pathToImages: "js/amcharts/images/",
            amExport: {
                top: 16,
                right: 20,
                exportPNG: true,
                imageFileName: "fleet-dashboard"
            }
        });
    }

    function linkSqiIdToDivId(sqiValue) {
        var divId = undefined;
        switch (sqiValue.sqiId) {
            case 101:
                divId = "sqi11";
                break;
            case 102:
                divId = "sqi12";
                break;
            case 103:
                divId = "sqi2";
                break;
            case 200:
                divId = "sqi-vung";
                break;
        }
        return divId;
    }

    var dataPollerPromise = undefined;

    function pollData() {
        stopPoller();
        dataPollerPromise = $timeout(function () {
            init();
        }, 120 * 1000);
    }

    function stopPoller() {
        if (util.isDefined(dataPollerPromise)) {
            $timeout.cancel(dataPollerPromise);
        }
        $scope.started = false;
    }

    $scope.$on('$destroy', function () {
        stopPoller();
    });
}];